var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "value": true,
      "width": _vm.width,
      "mask-closable": false,
      "closable": false,
      "transfer": _vm.transfer,
      "footer-hide": _vm.footerHide
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "ios-close",
      "size": "32"
    },
    on: {
      "click": _vm.close
    }
  })], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('Button', {
    staticClass: " ml-20",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])], 1)], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d831458","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseModal/index.vue
// module id = VkQ9
// module chunks = 142